import React from 'react';

function FeatureCards() {
    return (
        <section className="feature-cards-section">
            <div className="section-content">
                <div className="footer-features">
                    <div className="footer-feature-card">
                        <div className="footer-feature-icon" style={{ filter: 'drop-shadow(0 0 12px rgba(255, 193, 7, 0.6))' }}>⚡</div>
                        <h4 className="footer-feature-title">30-60-90 day launch</h4>
                        <p className="footer-feature-desc">Week 1 early wins guaranteed</p>
                    </div>
                    <div className="footer-feature-card">
                        <div className="footer-feature-icon" style={{ filter: 'drop-shadow(0 0 12px rgba(168, 85, 247, 0.6))' }}>🏨</div>
                        <h4 className="footer-feature-title">Built by hoteliers for hoteliers</h4>
                        <p className="footer-feature-desc">Houston, TX</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeatureCards;

